<script setup>
import { useConfigStore } from '@core/stores/config'
import { switchToVerticalNavOnLtOverlayNavBreakpoint } from '@layouts/utils'
import AppLoadingIndicatorByStore from "@/components/AppLoadingIndicatorByStore.vue"

const DefaultLayoutWithVerticalNav = defineAsyncComponent(() => import('./components/DefaultLayoutWithVerticalNav.vue'))
const configStore = useConfigStore()

// ℹ️ This will switch to vertical nav when define breakpoint is reached when in horizontal nav layout

// Remove below composable usage if you are not using horizontal nav layout in your app
switchToVerticalNavOnLtOverlayNavBreakpoint()

const { layoutAttrs, injectSkinClasses } = useSkins()

injectSkinClasses()

</script>

<template>
  <Component
    v-bind="layoutAttrs"
    :is="DefaultLayoutWithVerticalNav"
  >
<!--    <AppLoadingIndicator ref="refLoadingIndicator" />-->
    <AppLoadingIndicatorByStore/>

    <RouterView v-slot="{ Component }">
      <Suspense
        :timeout="0"
        @fallback="configStore.showAppLoadingIndicator = true"
        @resolve="configStore.showAppLoadingIndicator = false"
      >
        <Component :is="Component" />
      </Suspense>
    </RouterView>
  </Component>
</template>

<style lang="scss">
// As we are using `layouts` plugin we need its styles to be imported
@use "@layouts/styles/default-layout";
</style>
